import React from 'react';
import { useLocation } from 'react-router-dom';
import { StyledNavbar } from '@/components/ui/NavBar/NavBar.styled.ts';
import RevelLogo from '@/assets/logo/REVEl.png';
import LogoutButton from '@/components/ui/LogoutButton';
import AuthCookieHandler from '@/services/AuthCookieHandler';

const NavBar: React.FunctionComponent = () => {
  const authCookieHandler = new AuthCookieHandler();
  const isAuthenticated = authCookieHandler.isAuthenticated();
  const location = useLocation();

  const isAdminRoute = location.pathname.includes('/admin');

  return (
    <StyledNavbar>
      <img src={RevelLogo} alt="REVEL" />
      {isAuthenticated && isAdminRoute && <LogoutButton />}
    </StyledNavbar>
  );
};

export default NavBar;
